import dayjs from 'dayjs';
import { Tone } from 'styles/mobile';
import { IEvent } from 'types';

// 이벤트 상태 텍스트 매핑
const EVENT_STATUS_TEXT = {
  REVIEW: '리뷰 중',
  RECRUITING: '모집 중',
  RECRUITMENT_CLOSED: '모집 완료',
  COMPLETED: '봉사 종료',
  CANCELLED: '취소된 봉사',
} as const;

export const getEventStatus = (
  eventStatus: IEvent['eventStatus'],
  startDate: string,
  endDate: string,
  enrollStartDate: string,
  enrollEndDate: string,
) => {
  const now = dayjs();
  const dates = {
    start: dayjs(startDate),
    end: dayjs(endDate),
    enrollStart: dayjs(enrollStartDate),
    enrollEnd: dayjs(enrollEndDate),
  };

  if (eventStatus === 'RECRUITING') {
    if (now.isBefore(dates.enrollStart)) return '모집 예정';
    if (now.isAfter(dates.enrollEnd)) return '모집 완료';
    return '모집 중';
  }

  if (eventStatus === 'RECRUITMENT_CLOSED') {
    if (now.isAfter(dates.end)) return '봉사 종료';
  }

  return EVENT_STATUS_TEXT[eventStatus];
};

const EVENT_STATUS_TONE: Record<string, Tone> = {
  '모집 중': 'info',
  '모집 완료': 'success',
  '취소된 봉사': 'error',
};

export const getEventStatusTone = (status: string): Tone =>
  EVENT_STATUS_TONE[status] ?? 'grey';
